import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import _ from 'lodash';
import bemify from 'bemify-js';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import NotificationBell from 'app/viewport/components/NotificationBell';
import NotificationShape from 'app/viewport/NotificationShape';
import NotificationsDropdown from 'app/viewport/components/NotificationsDropdown';
import OutsideClickable from 'app/common/components/OutsideClickable';
import { Div } from 'app/common/components/AccessibleElement';
import { isNew, isRead } from 'app/viewport/utils/notification';
import 'app/viewport/components/NotificationsMenu.scss';

const bem = bemify('notifications-menu');

const NotificationsMenu = createReactClass({
  displayName: 'NotificationsMenu',
  mixins: [PureRenderMixin],

  propTypes: {
    notifications: PropTypes.arrayOf(PropTypes.shape(NotificationShape)),
    isDropdownOpen: PropTypes.bool.isRequired,
    onToggleDropdown: PropTypes.func.isRequired,
    onNotificationCta: PropTypes.func.isRequired,
    onNotificationsDelivered: PropTypes.func.isRequired,
    onDismissNotification: PropTypes.func.isRequired,
  },

  getDefaultProps() {
    return {
      isDropdownOpen: false,
      isImportant: false,
    };
  },

  onClickOutside() {
    if (this.props.isDropdownOpen) {
      this.props.onToggleDropdown();
    }
  },

  render() {
    const { props } = this;
    const notifications = props.notifications;
    const unreadCount = notifications.filter(n => !isRead(n.notificationStatus))
      .length;
    const hasUndelivered = _.some(notifications, n =>
      isNew(n.notificationStatus)
    );
    const hasImportant = _.some(notifications, n => n.isImportant);
    const onBellRingFinished = _.partial(
      props.onNotificationsDelivered,
      notifications
    );

    return (
      <Div
        aria-expanded={props.isDropdownOpen}
        aria-label={`${
          props.isDropdownOpen ? 'Close' : 'Open'
        } notifications menu`}
        className={bem()}
        onClick={props.onToggleDropdown}
      >
        <NotificationBell
          hasImportant={hasImportant}
          hasUndelivered={hasUndelivered}
          onBellRingFinished={onBellRingFinished}
          unreadCount={unreadCount}
        />
        {!props.isDropdownOpen ? null : (
          <OutsideClickable onClickOutside={this.onClickOutside}>
            <NotificationsDropdown
              notifications={notifications}
              onClose={props.onToggleDropdown}
              onDismissNotification={props.onDismissNotification}
              onNotificationCta={props.onNotificationCta}
            />
          </OutsideClickable>
        )}
      </Div>
    );
  },
});

export default NotificationsMenu;
